// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"e12de532","936":"e12de532"}[chunkId] + ".chunk.css";
};